export default "__VITE_ASSET__CdHlC6cE__"